import {getPublicUrl} from "@/shared/utils/env";

export const DEFAULT_SEO_CONFIG = {
    baseUrl: getPublicUrl(),
    defaultTitle: "Casago - Vacation Rentals",
    defaultDescription: "Casago Vacation Rentals - Find your perfect vacation rental",
    siteName: "Casago",
    defaultOgImage: "",
    twitterSite: "@casago",
} as const;

export const PAGE_NOT_FOUND = {
    title: "Page Not Found",
    description: "This page does not exist.",
};
